import { render, staticRenderFns } from "./DeliveryAll.vue?vue&type=template&id=0d1c775e&scoped=true"
import script from "./DeliveryAll.vue?vue&type=script&lang=js"
export * from "./DeliveryAll.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAll.vue?vue&type=style&index=0&id=0d1c775e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c775e",
  null
  
)

export default component.exports